export enum MaintenanceSettingsTab {
  MaintenanceConfiguration = 'maintenanceConfiguration',
  Workshops = 'workshops'
}

export enum WorkshopType {
  InHouse = 1,
  External = 2
}